module.exports = __webpack_public_path__ + "img/T5-A-xh_13.52f0c9e9.png";